import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

class WebComponent extends HTMLElement {
    connectedCallback() {
        // Create a root element and render the App component into it
        const root = ReactDOM.createRoot(this);
        root.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>
        );
    }

    disconnectedCallback() {
        // Unmount the component when disconnected
        const root = ReactDOM.createRoot(this);
        root.unmount();
    }
}

const ELEMENT_NAME = 'reactjs-ext-bicici-reset-password';

if (customElements.get(ELEMENT_NAME)) {
    // eslint-disable-next-line no-console
    console.log(`Skipping registration for <${ELEMENT_NAME}> (already registered)`);
} else {
    customElements.define(ELEMENT_NAME, WebComponent);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
